<template>
  <div class="wrapper">
    <div class="list-wrp">
      <van-tabs style="height: 100%" v-model="active" @click="onTabClick">
        <van-tab title="待办">
          <TodoList v-if="active === 0"/>
        </van-tab>
        <van-tab title="消息">
          <Message v-if="active === 1"/>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Message from './Message'
import TodoList from './TodoList'
import { Tab, Tabs } from 'vant'
import { getQuery } from '@utils/basicUtil'
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Message,
    TodoList
  },
  props: {},
  data () {
    return {
      active: 0
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.initActive()
  },
  activated () {},
  updated () {},
  methods: {
    initActive () {
      let { active } = getQuery()
      if (active === '0' || active === '1') {
        this.active = Number(active)
      }
    },
    onTabClick (name) {
      this.$router.replace(`/message/center?active=${name}`)
    }
  }
}
</script>
<style lang="less" scoped>
.wrapper{
  .list-wrp{
    /deep/.van-tabs__wrap{
      margin-bottom: 20px;
      height: 80px !important;
      margin-bottom: 0;
    }

    /deep/.van-tab__text--ellipsis {
      overflow: visible;
    }

    /deep/.van-tabs__content {
      flex: 1;
    }
    /deep/.van-tab {
      font-size:30px;
      color:rgba(153,153,153,1);
    }
    /deep/.van-tab--active {
      color: #4573DE;
    }

    /deep/.van-tabs__line {
      width:160px;
      height: 6px;
      background-color: #4573DE;
      display: flex;
      flex-direction: column;
    }
    /deep/.van-tabs--line{
      // display: flex;
      // flex-direction: column;
    }
    /deep/.van-tab__pane{
      // height: 100%;
    }
    /deep/.van-info {
      width:35px;
      height:35px;
      font-size:24px;
      line-height: 35px;
      padding: 0;
      border-radius: 50%;
      background-color: #EC547A;
    }
  }
}
</style>
